<template>
  <gs-card :class="['gs-stat', `gs-stat--${tone}`]">
    <span class="gs-stat__rule" aria-hidden="true"></span>
    <div class="gs-stat__body">
      <div class="gs-stat__text">
        <p class="gs-stat__label">{{ label }}</p>
        <p class="gs-stat__value">{{ value }}</p>
        <p class="gs-stat__note">{{ note }}</p>
      </div>
      <span class="gs-stat__icon">
        <gs-icon :name="icon" size="18" />
      </span>
    </div>
  </gs-card>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: '0' },
    note: { type: String, default: '' },
    icon: { type: String, default: 'chart' },
    tone: {
      type: String,
      default: 'slate',
      validator: value => ['blue', 'green', 'amber', 'violet', 'pink', 'slate'].indexOf(value) !== -1,
    },
  },
};
</script>

<style scoped>
/* Every tone is one kit token. The soft icon tint is derived from that same
   token at 8% by the ::before wash below, so no colour literal lives here. */
.gs-stat--blue {
  --gs-stat-accent: var(--gs-active);
}

.gs-stat--green {
  --gs-stat-accent: var(--gs-success);
}

.gs-stat--amber {
  --gs-stat-accent: var(--gs-warning);
}

.gs-stat--violet {
  --gs-stat-accent: var(--gs-info);
}

.gs-stat--pink {
  --gs-stat-accent: var(--gs-primary);
}

.gs-stat--slate {
  --gs-stat-accent: var(--gs-muted-foreground);
}

.gs-stat {
  position: relative;
  overflow: hidden;
  padding: 18px 20px 16px;
}

.gs-stat__rule {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 2px;
  background: var(--gs-stat-accent);
}

.gs-stat__body {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
}

.gs-stat__text {
  min-width: 0;
}

.gs-stat__label {
  margin: 0 0 6px;
  color: var(--gs-muted-foreground);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.gs-stat__value {
  margin: 0;
  color: var(--gs-foreground);
  font-size: 28px;
  font-weight: 700;
  line-height: 1.15;
  font-variant-numeric: tabular-nums;
}

.gs-stat__note {
  margin: 6px 0 0;
  color: var(--gs-muted-foreground);
  font-size: 12px;
  line-height: 1.4;
}

.gs-stat__icon {
  position: relative;
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: var(--gs-stat-accent);
  border-radius: var(--gs-radius-md);
}

/* 8% wash of the tone token — keeps the boxed icon tinted without a second
   colour value per tone. */
.gs-stat__icon::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: currentColor;
  border-radius: inherit;
  opacity: .08;
}

.gs-stat__icon > svg {
  position: relative;
}
</style>
